<template>
  <div :class="validationContainerClass">
    <v-validate :rules="rules" v-slot="{ errors, classes }" :name="label">
      <div class="form-group">
        <label :for="id"
          >{{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i></div
        ></label>
        <textarea
          :id="inputID"
          :name="name"
          :ref="name"
          :type="type"
          :class="`${inputClass} ${classes.invalid ? 'is-invalid' : ''}`"
          :rows="rows"
          :maxlength="maxLength"
          :placeholder="placeHolder"
          v-model="content"
          @input="handleInput(content)"
        />
      </div>
      <span class="invalid-feedback">{{ errors[0] }}</span>
    </v-validate>
  </div>
</template>
<script>
import InputCommons from "./InputCommons.vue";
export default {
  extends: InputCommons,
};
</script>
